import { AfterViewInit, Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { CreatureWebFilterDto } from '../../../../dtos/creature.web.filter.dto';
import { EmptyPageComponent } from '../../../components/empty-page/empty-page.component';
import { CreaturesService } from '../../../../services/creatures.service';
import { CreatureLiteWebDto } from '../../../../dtos/creature.lite.web.dto';
import { FilterCreatureComponent } from './components/filter/filter-creature.component';
import { ItemCreatureComponent } from './components/item/item-creature.component';
import { RouterLink } from '@angular/router';
import { CreatureSortType } from '../../../../enums/creature-sort.type';
import { CreatureSortTypePipe } from '../../../../pipes/creature-sort-type.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BreedingOrderStatus } from '../../../../enums/breeding-order.status';

@Component({
  selector: 'list-creature-page',
  templateUrl: './list-creature.page.html',
  styleUrl: './list-creature.page.scss',
  imports: [
    RouterLink,
    CommonModule,
    EmptyPageComponent,
    FilterCreatureComponent,
    ItemCreatureComponent,
    CreatureSortTypePipe,
    TranslateModule
  ]
})
export class ListCreaturePage implements OnInit, AfterViewInit {

  public sortType: typeof CreatureSortType = CreatureSortType;
  public lang: string | null = null;

  @Input()
  public onlyMy: boolean = true;

  public hasMore = true;

  public countOfFilterChanged: number = 0;
  public showMobileFilter: boolean = false;
  public filter: CreatureWebFilterDto = {
    onlyMy: false,
    onlyForTrade: true,
    availableForBreeding: null,
    minHp: null,
    maxHp: null,
    minLevel: null,
    maxLevel: null,
    minPrice: null,
    maxPrice: null,
    isChildren: false,
    isParent: false,
    abilityIds: [],
    types: [],
    rarities: [],
    ignoreIds: [],
    nftTokenIds: [],
    nftParentTokenId: null,
    page: 0,
    pageSize: 20,
    sortBy: CreatureSortType.PriceAsc
  };

  public creatures: CreatureLiteWebDto[] | null = null;
  public breedingOrderCount: number | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly creaturesService: CreaturesService,
    private readonly translateService: TranslateService,
  ) {
    this.lang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event) => {
      this.lang = event.lang;
    })
  }

  ngOnInit(): void {
    this.filter.onlyMy = this.onlyMy;
    this.filter.onlyForTrade = !this.onlyMy;

    this.onFilterChange();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {

    }
  }

  public showLoading: boolean = false;
  public showBreedingLoading: boolean = false;
  onFilterChange(refreshState: boolean = true) {
    this.showLoading = true;

    if (this.filter.onlyMy) {
      this.showBreedingLoading = true;
      this.creaturesService.getBreedingByFilter().subscribe({
        next: (breedingOrders) => {
          if (breedingOrders.length === 0) {
          } else {
            this.breedingOrderCount = breedingOrders?.filter(o => o.breedingOrder.status === BreedingOrderStatus.Pending).length ?? 0;
          }
          this.showBreedingLoading = false;
        },
        error: (err) => {
          console.error('Failed to load creatures:', err);
          this.showBreedingLoading = false;
        },
      });
    }

    if (refreshState) {
      this.filter.page = 0;
      this.hasMore = true;
      this.creatures = [];
    }

    this.creaturesService.getByFilter(this.filter).subscribe({
      next: (newCreatures) => {
        if (newCreatures.length === 0) {
          this.hasMore = false;
        } else {
          this.creatures = [...(this.creatures ?? []), ...newCreatures];
        }
        this.showLoading = false;
      },
      error: (err) => {
        console.error('Failed to load creatures:', err);
        this.showLoading = false;
      },
    });

    this.countOfFilterChanged = 0;
    if (this.filter.minHp) {
      this.countOfFilterChanged++;
    }
    if (this.filter.maxHp) {
      this.countOfFilterChanged++;
    }
    if (this.filter.minLevel) {
      this.countOfFilterChanged++;
    }
    if (this.filter.maxLevel) {
      this.countOfFilterChanged++;
    }
    if (this.filter.minPrice) {
      this.countOfFilterChanged++;
    }
    if (this.filter.maxPrice) {
      this.countOfFilterChanged++;
    }
    if (this.filter.abilityIds && this.filter.abilityIds.length > 0) {
      this.countOfFilterChanged++;
    }
    if (this.filter.types && this.filter.types.length > 0) {
      this.countOfFilterChanged++;
    }
    if (this.filter.rarities && this.filter.rarities.length > 0) {
      this.countOfFilterChanged++;
    }

  }

  onCloseMobileFilter() {
    this.showMobileFilter = false;
  }

  async onScroll(event: Event) {
    const target = event.target as HTMLElement;
    if (this.showLoading || !this.hasMore) return;

    const threshold = 150;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - threshold) {
      this.filter.page++;
      await this.onFilterChange(false);
    }
  }

}
